module.exports = __webpack_public_path__ + "img/21.614fdc41.png";